import type { QueryFunctionContext } from '@tanstack/react-query';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import { AsrModelSettingsService } from 'app/API/custom/asr-model-settings/AsrModelSettingsService';
import type { asrProxyKeys } from 'app/queries/asrProxy/asrProxyKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof asrProxyKeys.modelSettings>>;

export const createFetchAsrModelSettingsQueryFn =
  (call: TCall) =>
  ({ signal }: TParams) =>
    call(() => cancelOnSignal(AsrModelSettingsService.getModelSettings(), signal), { dontRedirectOnError: true });
